import { frontendURL } from '../../../helper/URLHelper';
import LandRecordsIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ardhisasa/land-records'),
    name: 'ardhisasa_land_records',
    component: LandRecordsIndex,
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
  },
];
